import { z } from 'zod';

export const schema = z.object({
  firstName: z.string().min(1, { message: 'required' }),
  lastName: z.string().min(1, { message: 'required' }),
  organisationName: z.string().min(1, { message: 'required' }),
  phoneNumber: z.string().min(1, { message: 'required' }),
});

export type FormUserAndPromoter = z.infer<typeof schema>;
